import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { z } from "zod";
import { JobDetail } from "@/features/job-post/job-detail";
import {
  getRecruiterUserIdFromStorage,
  setRecruiterUserIdInStorage,
  clearRecruiterUserIdFromStorage,
} from "@/features/recruiter-tracking/recruiterCode";

export const Route = createFileRoute("/_provider/provider/jobs/$id/")({
  validateSearch: z.object({
    ref: z.string().uuid().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { ref } = Route.useSearch();
  const [sourceUserId, setSourceRecruiterUserId] = useState<string | null>(
    null,
  );

  useEffect(() => {
    const init = async () => {
      if (ref) {
        await setRecruiterUserIdInStorage(id, ref);

        // Strip ?ref= from the URL without triggering a navigation
        const url = new URL(window.location.href);
        url.searchParams.delete("ref");
        history.replaceState(null, "", url.toString());
      }

      const stored = await getRecruiterUserIdFromStorage(id);
      setSourceRecruiterUserId(stored);
    };

    init().catch(console.error);
  }, [id, ref]);

  const handleDecisionAccepted = async () => {
    await clearRecruiterUserIdFromStorage(id);
    setSourceRecruiterUserId(null);
  };

  return (
    <JobDetail
      jobId={id}
      sourceUserId={sourceUserId}
      onDecisionAccepted={handleDecisionAccepted}
    />
  );
}
